import React from 'react';
import './NetworkHeader.css';

const NetworkHeader = React.memo(({ onNavigate, memberCount, onAddMember }) => {
  return (
    <div className="network-header">
      <button className="back-button" onClick={() => onNavigate('dashboard')}>
        ← Back to Dashboard
      </button>
      <h1>My Network Tree</h1>
      <div className="header-actions">
        <div className="member-count">
          {memberCount || 0} members
        </div>
        <button className="add-member-button" onClick={onAddMember}>
          + Add Member
        </button>
      </div>
    </div>
  );
}, (prevProps, nextProps) => {
  // Only re-render if these props change
  return prevProps.memberCount === nextProps.memberCount;
});

NetworkHeader.displayName = 'NetworkHeader';

export default NetworkHeader;

